import * as actionTypes from '../constants/actionTypes';
import * as actions from './index';
import _ from 'lodash';
import { hashHistory } from 'react-router';

export function loadEditor(name) {
  return (dispatch, getState) => {
    let state = getState();
    if (!state.editor || !state.editor.name) {
      var msgBoxOptions = {
        visible: true,
        title: "Unsaved changes detected",
        type: "system",
        message: "Load unsaved changes?",
        buttons: [{
          text: 'Yes',
          subtext: 'Load unsaved changes',
          onClick: () => {
            dispatch({
              type: actionTypes.LOAD_STORED_TRANSIENT_UPDATES,
              payload: { auth: state.auth }
            });
            
            dispatch({
              type: actionTypes.POST_LOAD_STORED_TRANSIENT_UPDATES,
              payload: getState()
            });
            dispatch({
              type: actionTypes.POPUP_MESSAGE_BOX_SHOW,
              payload: { auth: state.auth }
            });
          }
        }, {
          text: 'No',
          subtext: 'Clear unsaved changes',
          onClick: () => {
            dispatch({
              type: actionTypes.CLEAR_TRANSIENT_UPDATES,
              payload: { auth: state.auth }
            });
            dispatch({
              type: actionTypes.POPUP_MESSAGE_BOX_SHOW,
              payload: null
            });
          }
        }]
      };
      if (getTransientUpdateCount(state.auth) > 0) {
        dispatch({
          type: actionTypes.POPUP_MESSAGE_BOX_SHOW,
          payload: msgBoxOptions
        });
      }
    }
    return dispatch({
      type: actionTypes.LOAD_EDITOR,
      payload: { name }
    });
  }
}

export function unloadEditor() {
  return {
    type: actionTypes.UNLOAD_EDITOR
  };
}

export function getTransientUpdateCount(auth) {
  var updateCount = 0;
  var updateData = localStorage.getItem(`pending-updates-${auth.fabricatorId}`);
  if (updateData) {
    try {
      var data = JSON.parse(updateData);
      return data.state.transientUpdates;
    } catch (ex) {
      console.log(ex);
    }
  }
  return 0;
}

export function getItemUpdateCount(state) {
  var updateCount = 0;
  _.each(state.updatedTypes, (type) => {
    _.each(type, (item) => {
      updateCount++;
    });
  });
  return updateCount;
}

function getStoredTransientUpdates(state, auth) {
  const { transientUpdates, updateItems, updateTypes, ...rest } = state;
  var updateData = localStorage.getItem(`pending-updates-${auth.fabricatorId}`);
  var updates = getCleanState();
  if (updateData) {
    try {
      updates = JSON.parse(updateData);
    } catch (ex) {
      console.log(ex);
    }
  }
  return { ...rest, ...updates.state, firstLoad: false };
}

export function updateTransientField(item, key, value, additionalValueData) {
  return function (dispatch, getState) {
    const { editor, auth } = getState();
    if (!editor.name) {
      return dispatch({
        type: actionTypes.UPDATE_TRANSIENT_FIELD,
        payload: new Error('No editor is active'),
        error: true
      });
    }

    const editorName = editor.name;
    return dispatch({
      type: actionTypes.UPDATE_TRANSIENT_FIELD,
      payload: {
        editorName,
        item,
        key,
        value,
        additionalValueData,
        auth
      }
    });
  };
}

export function updateTransientFieldForCustomEditor(editorName, item, key, value) {
  return function (dispatch, getState) {
    const { auth } = getState();
    return dispatch({
      type: actionTypes.UPDATE_TRANSIENT_FIELD,
      payload: {
        editorName,
        item,
        key,
        value,
        auth
      }
    });
  };
}

export function enableAllTransientStones(stones, enable = true) {
  let action = (enable ? 'Enabling' : 'Disabling');
  return function (dispatch, getState) {
    dispatch(actions.loadingDialog_show(true, `${action} all stones`, `Please wait, this can take a moment...`))
      .then(() => {
        return new Promise((resolve) => {
          const { editor, auth } = getState();
          if (!editor.name) {
            return dispatch({
              type: actionTypes.UPDATE_TRANSIENT_FIELD,
              payload: new Error('No editor is active'),
              error: true
            });
          }

          const editorName = editor.name;
          dispatch({
            type: actionTypes.UPDATE_TRANSIENT_FIELDS,
            payload: {
              editorName,
              fields: stones,
              key: 'enabled',
              value: enable,
              auth
            },
            resolve
          });
        });
      }).then(() => dispatch(actions.loadingDialog_show(false)));
  }
}
